/**
 * @generated SignedSource<<70f5ea67534d8cbbc1aff315d75e028a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TodoEditNewMainMediaComponentMedia_todo$data = {
  readonly canWrite: boolean;
  readonly id: string;
  readonly images: ReadonlyArray<{
    readonly id: string;
    readonly sizes: ReadonlyArray<{
      readonly height: number;
      readonly width: number;
    }>;
    readonly " $fragmentSpreads": FragmentRefs<"Image_image" | "LinkedContentInput_images">;
  }>;
  readonly isOrg: boolean;
  readonly " $fragmentType": "TodoEditNewMainMediaComponentMedia_todo";
};
export type TodoEditNewMainMediaComponentMedia_todo$key = {
  readonly " $data"?: TodoEditNewMainMediaComponentMedia_todo$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoEditNewMainMediaComponentMedia_todo">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoEditNewMainMediaComponentMedia_todo",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canWrite",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isOrg",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "images",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "ImageSize",
          "kind": "LinkedField",
          "name": "sizes",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "height",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "width",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "LinkedContentInput_images"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "Image_image"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Todo",
  "abstractKey": null
};
})();

(node as any).hash = "6614ac53442f1e73d3d1a89adeeedbe2";

export default node;
